<div class="pill pill-{{ theme }}" [style.width]="fixedWidth ? fixedWidth : null">
  {{ label }}
</div>
